/**
 * Compresse une photo avant l'envoi.
 * Une photo d'iPhone fait 3 a 5 Mo ; apres compression, environ 600 Ko
 * pour une qualite qui reste excellente a l'ecran comme a l'impression.
 */

const LARGEUR_MAX = 2048;
const QUALITE = 0.85;

export const compresser = (fichier) =>
  new Promise((resoudre) => {
    // On ne touche pas aux fichiers deja legers
    if (!fichier || !fichier.type?.startsWith('image/') || fichier.size < 700 * 1024) {
      return resoudre(fichier);
    }

    const lecteur = new FileReader();
    lecteur.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        try {
          let { width: l, height: h } = img;
          if (l > LARGEUR_MAX || h > LARGEUR_MAX) {
            const ratio = LARGEUR_MAX / Math.max(l, h);
            l = Math.round(l * ratio);
            h = Math.round(h * ratio);
          }

          const toile = document.createElement('canvas');
          toile.width = l;
          toile.height = h;
          const ctx = toile.getContext('2d');
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, l, h);

          toile.toBlob(
            (blob) => {
              if (!blob || blob.size >= fichier.size) return resoudre(fichier);
              resoudre(new File([blob], fichier.name || 'photo.jpg', {
                type: 'image/jpeg',
                lastModified: Date.now(),
              }));
            },
            'image/jpeg',
            QUALITE
          );
        } catch (err) {
          resoudre(fichier);
        }
      };
      img.onerror = () => resoudre(fichier);
      img.src = e.target.result;
    };
    lecteur.onerror = () => resoudre(fichier);
    lecteur.readAsDataURL(fichier);
  });
